import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login/Login'
import Dashboard from '@/views/dashboard/Dashboard'
import Orders from '@/views/orders/Orders'
import Clients from '@/views/clients/Clients'
import Equipments from '@/views/equipments/Equipments'
import EquipmentsList from '@/views/equipments/EquipmentsList'
import Equipment from '@/views/equipments/Equipment'
import EquipmentDetails from '@/views/equipments/EquipmentDetails'
import EquipmentRegister from '@/views/equipments/EquipmentRegister'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: Dashboard,
  // },
  // {
  //   path: '/orders',
  //   name: 'orders',
  //   component: Orders,
  // },
  // {
  //   path: '/clients',
  //   name: 'clients',
  //   component: Clients,
  // },
  // {
  //   path: '/equipments',
  //   name: 'equipments',
  //   component: Equipments, //by clients
  // },
  {
    path: '/equipment-register',
    name: 'Register',
    component: EquipmentRegister,
  },
  {
    path: '/equipment-list',
    name: 'equipment-list',
    component: EquipmentsList,
  },
  // {
  //   path: '/equipment',
  //   name: 'equipment',
  //   component: Equipment,
  // },
  {
    path: '/equipment-details',
    name: 'equipment-details',
    component: EquipmentDetails,
  },
]

const router = new VueRouter({
  routes
})
// router.beforeEach((to, from, next) => {
//   if (
//       to.name !== 'Login' && 
//       (localStorage.getItem('logged') == 'false')
//   ) {
//       console.log('não logado')
//       next({ name: 'Login' })
//       return
//   }
export default router
